exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".home_page .covid_alert {\r\n    margin-left: 10px;\r\n}\r\n\r\n.home_page .covid_alert:focus {\r\n    margin-left: 10px;\r\n    outline:2px solid white;\r\n}\r\n\r\n.contact_us .outage-icon:before {\r\n    color: rgb(205, 4, 11);\r\n}\r\n\r\n.contact_us .contactus_alert {\r\n    margin-bottom: 1rem;;\r\n}\r\n\r\n.contact_us a.covid_alert {\r\n    font-weight: 900;\r\n    text-decoration: none;\r\n    display: block;\r\n}\r\n\r\n.contact_us .contactus_wrapper {\r\n    padding-right: 0 !important;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoaders=1!./~/postcss-loader!./src/assets/css/Covidalert.css
// module id = 1752
// module chunks = 0